export const BENEFIT_OPTION_LABELS = {
  health_coverage_guidance: 'Health Coverage / HRA / ACA Guidance',
  dental_vision_options: 'Dental / Vision / Supplemental Benefits',
  retirement_savings_options: 'Retirement Savings / Financial Wellness',
  employee_financial_wellness: 'Employee Financial Wellness',
  mental_health_eap: 'EAP / Mental Health / Workforce Wellness',
  payroll_hr_coordination: 'Payroll / HR Coordination',
  not_sure_yet: 'NCAF Education Follow-Up Before Referral',
};

export const FINAL_NCAF_DISCLAIMER =
  'NCAF provides readiness guidance and partner coordination support only. NCAF does not act as an insurance broker, benefits administrator, payroll provider, legal advisor, tax advisor, employer, or state licensing authority. Final benefit design, compliance review, pricing, enrollment, and implementation must be completed directly with qualified licensed or authorized partners.';

export const PROVIDER_PREPARE_ITEMS = [
  'Current staff count',
  'Full-time / part-time staff breakdown',
  'Payroll provider, if any',
  'Pay cycle',
  'Estimated monthly contribution direction or budget range',
  'Desired launch or review timeline',
  'Decision-maker contact',
  'Current benefits documents, if any',
  'Employee benefits interests or feedback, if available',
  'HR/payroll challenges that may affect implementation',
];

export const EDUCATION_NEED_LABELS = {
  benefits_options_overview: "Benefits Options Overview",
  health_coverage_basics: "Health Coverage Basics",
  supplemental_benefits: "Supplemental Benefits",
  retirement_options: "Retirement Options",

  costs_and_budgeting: "Costs & Budgeting",

  provider_obligations: "Provider Obligations",
  payroll_hr_setup: "Payroll / HR Setup",
  employee_interest: "Employee Interest",

  employee_eligibility: "Employee Eligibility",
  compliance_responsibilities: "Compliance Responsibilities",

  ncaf_partner_coordination: "NCAF Partner Coordination",
};